import React from 'react';
export function OpeningHook() {
  return <section className="w-full bg-[#f8fafc] py-16 px-4" data-id="element-205">
      <div className="max-w-4xl mx-auto" data-id="element-206">
        <div className="border-l-4 border-[#fbbf24] pl-6 md:pl-8" data-id="element-207">
          <p className="text-lg md:text-xl text-[#1a2332] leading-relaxed mb-4" data-id="element-208">
            Vivir solo en Chile se convirtió en un lujo silencioso. Entras al
            Jumbo o al Lider por "tres cositas", sales con dos bolsas medianas y
            la cuenta marca $45.000. Miras la boleta y no entiendes en qué se
            fue el sueldo.
          </p>
          <p className="text-lg md:text-xl text-[#1a2332] leading-relaxed mb-4" data-id="element-209">
            No es tu imaginación y no es solo la inflación.
          </p>
          <p className="text-lg md:text-xl text-[#1a2332] leading-relaxed font-semibold" data-id="element-210">
            El sistema está diseñado para que la persona que vive sola pague más
            por gramo, desperdicie más comida y caiga en la trampa del ahorro
            falso de las etiquetas rojas.
          </p>
        </div>
      </div>
    </section>;
}